import defaultPsychologistImage from '@avanta/shared/assets/avatar.svg';
import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import type { Appointment } from 'types/appointments';

interface PsychologistInfoProps {
  appointment: Appointment;
}

export const PsychologistInfo = ({ appointment }: PsychologistInfoProps): React.ReactElement => {
  const psychologist = appointment.psychologist?.psychologist;
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const fullName = [psychologist?.name, psychologist?.surname].filter(Boolean).join(' ');

  return (
    <div className="flex w-full h-full max-w-102 gap-4 border-l-2 border-teal-300 px-4 py-4 bg-plum-100 rounded-r-xl shrink-0 max-h-32">
      <div className="size-24 shrink-0 overflow-hidden rounded-full bg-gray-200">
        <img
          className="size-full object-cover"
          src={psychologist?.imageSquare || defaultPsychologistImage}
          alt={fullName}
          width={96}
          height={96}
        />
      </div>
      <div className="flex min-w-0 flex-col">
        <Text variant="text-xs-medium" className="text-denim-800 mb-2">
          {t('AppointmentCard.facultative.label')}
        </Text>
        <Text variant="text-md-medium" className="text-denim-800 truncate">
          {fullName}
        </Text>
        {psychologist?.professionalNumber && (
          <Text variant="text-xs-medium" className="text-gray-400">
            {t('AppointmentsReserve.FacultativeCard.professionalNumber', {
              professionalNumber: psychologist.professionalNumber,
            })}
          </Text>
        )}
      </div>
    </div>
  );
};
